import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "style", "providerOptions"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { createContext, forwardRef, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { compose } from '@beef/utils';
import { withDataConverter } from '@beef/react';
import { cnBem } from '@carnica/utils';
import { isEmpty, merge } from 'lodash';
import { convertComponentStylesToVariables, dataConverter, getThemeStyles } from "./utils";
import { MotionComponent } from "../MotionComponent";
import defaultStyles from "../../styles/themeV1.pcss";
var themeContext = /*#__PURE__*/createContext(['light', function () {}, {
  baseName: 'theme',
  componentStyles: {},
  initialTheme: 'light',
  themeStyles: {}
}]);
var ThemeProviderRender = function ThemeProviderRender(props, ref) {
  var children = props.children,
    classNameProp = props.className,
    style = props.style,
    providerOptions = props.providerOptions,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useThemeContext = useThemeContext(),
    _useThemeContext2 = _slicedToArray(_useThemeContext, 3),
    mainTheme = _useThemeContext2[0],
    _ = _useThemeContext2[1],
    options = _useThemeContext2[2];
  var isThemeManuallyChanged = useRef(false);
  var _merge = merge({}, options, providerOptions),
    initialTheme = _merge.initialTheme,
    _merge$baseName = _merge.baseName,
    baseName = _merge$baseName === void 0 ? 'theme' : _merge$baseName,
    componentStyles = _merge.componentStyles;
  var themeStyles = providerOptions.themeStyles || options.themeStyles;
  var _useState = useState(providerOptions.initialTheme || mainTheme),
    _useState2 = _slicedToArray(_useState, 2),
    theme = _useState2[0],
    setTheme = _useState2[1];
  var styles = useMemo(function () {
    if (isEmpty(themeStyles)) {
      return defaultStyles;
    }
    return getThemeStyles(themeStyles, theme);
  }, [theme, themeStyles]);
  var className = cnBem(baseName, styles)({
    theme: theme
  }, [classNameProp]);
  var value = useMemo(function () {
    return [theme, function (val) {
      setTheme(val);
      isThemeManuallyChanged.current = true;
    }, {
      initialTheme: initialTheme,
      themeStyles: themeStyles,
      baseName: baseName,
      componentStyles: componentStyles
    }];
  }, [theme, initialTheme, themeStyles, baseName, componentStyles]);
  useEffect(function () {
    if (!isThemeManuallyChanged.current) {
      setTheme(providerOptions.initialTheme || mainTheme);
    }
  }, [mainTheme, providerOptions.initialTheme]);
  return /*#__PURE__*/React.createElement(themeContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(MotionComponent, _extends({
    className: className,
    ref: ref,
    style: _objectSpread(_objectSpread({}, style), componentStyles ? convertComponentStylesToVariables(componentStyles, theme) : {})
  }, otherProps, {
    "data-t-id": "modules-ThemeProvider"
  }), typeof children === 'function' ? children(theme) : children));
};
export var useThemeContext = function useThemeContext() {
  return useContext(themeContext);
};
export var ThemeProvider = compose(withDataConverter(dataConverter), forwardRef)(ThemeProviderRender);